import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=3e62ef8e&scoped=true&"
import script from "./TagsView.vue?vue&type=script&lang=js&"
export * from "./TagsView.vue?vue&type=script&lang=js&"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=3e62ef8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e62ef8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e62ef8e')) {
      api.createRecord('3e62ef8e', component.options)
    } else {
      api.reload('3e62ef8e', component.options)
    }
    module.hot.accept("./TagsView.vue?vue&type=template&id=3e62ef8e&scoped=true&", function () {
      api.rerender('3e62ef8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TagsView.vue"
export default component.exports